import { useState, useEffect } from 'react';
import { useLocalStorage } from './useLocalStorage';
import { getChangesForVersion, type VersionChanges } from '@/utils/changelogParser';
// @ts-expect-error - Vite raw plugin
import changelogRaw from '../../CHANGELOG.md';

export function useWhatsNew() {
  const [lastSeenVersion, setLastSeenVersion] = useLocalStorage<string>(
    'whatsNewLastVersion', 
    '0.0.0'
  );
  const currentVersion = import.meta.env.VITE_APP_VERSION || '4.0.1';
  const versionChanges: VersionChanges | null = getChangesForVersion(changelogRaw, currentVersion);
  const changes: VersionChanges | null = versionChanges;
  const defaultShowModal: boolean = currentVersion !== lastSeenVersion && versionChanges && hasAnyChanges(versionChanges);
  const [showModal, setShowModal] = useState(defaultShowModal);

  
  useEffect(() => {
    if (currentVersion !== lastSeenVersion) {
      if (!versionChanges || !hasAnyChanges(versionChanges)) {
        setLastSeenVersion(currentVersion);
      }
    }
  }, [changes, currentVersion, lastSeenVersion, setLastSeenVersion]);

  const handleModalClose = (open: boolean) => {
    if (!open) {
      setLastSeenVersion(currentVersion);
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  };

  return {
    showModal,
    currentVersion,
    changes,
    handleModalClose
  };
}

function hasAnyChanges(changes: VersionChanges | null): boolean {
  if (!changes) {
    return false;
  }

  return (
    changes.added.length > 0 ||
    changes.changed.length > 0 ||
    changes.fixed.length > 0 ||
    changes.removed.length > 0
  );
}
